import { createAction, props } from '@ngrx/store';
import { Permissions } from './permissions.interface';

// Fetch permissions
export const fetchPermissions = createAction('[Permissions] Fetch Permissions');

export const fetchPermissionsSuccess = createAction(
	'[Permissions] Fetch Permissions Success',
	props<{ permissions: Permissions }>()
);

export const fetchPermissionsFailure = createAction(
	'[Permissions] Fetch Permissions Failure',
	props<{ error: any }>()
);

// Clear permissions
export const clearPermissions = createAction('[Permissions] Clear Permissions');
